/**
 * Centralised tag colour helpers.
 *
 * Used by: KanbanBoard, KanbanCardPlugins, TaskTagsField.
 *
 * getTagColorClass(label)
 *   Returns Tailwind bg/text/border classes for a tag pill.
 *   The border-* classes are harmless when no `border` utility is applied
 *   (KanbanBoard / KanbanCardPlugins), and become visible when `border` is
 *   added (TaskTagsField).
 *
 * getTagRemoveBtnClass(label)
 *   Returns Tailwind text/hover classes for the × remove button inside a pill.
 */

const DEV_TAGS = ['Dev', 'Backend', 'Bug', 'Ops'];

export const getTagColorClass = (label) => {
    if (label === 'Urgent') return 'bg-rose-50 text-rose-700 border-rose-200';
    if (DEV_TAGS.includes(label)) return 'bg-iris-50 text-iris-700 border-iris-100';
    return 'bg-slate-100 text-slate-600 border-slate-200';
};

export const getTagRemoveBtnClass = (label) => {
    if (label === 'Urgent') return 'text-rose-400 hover:text-rose-700';
    if (DEV_TAGS.includes(label)) return 'text-iris-400 hover:text-iris-800';
    return 'text-slate-400 hover:text-slate-700';
};
